import {Best} from './Best';
export default Best;
